import ReactGA from 'react-ga4';

export function performConversionScript() {
  ReactGA.gtag('event', 'conversion', {'send_to': 'AW-728729200/zHGfCJXrv4AYEPCMvtsC'});
  ReactGA.gtag('event', 'conversion', {'send_to': 'AW-11011736688/IVAECPrwv4AYEPCI54Ip'});
}